const $ = require('cash-dom');

const ShareButtons = {
  init() {
    $('body').on('click', '.facebook-share', function (e) {
      e.preventDefault();
      window.open("https://www.facebook.com/sharer/sharer.php?u=" + $(this).data('url'), 'fbShareWindow', 'height=450, width=550, top=' + ($(window).height() / 2 - 275) + ', left=' + ($(window).width() / 2 - 225) + ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');
      return false;
    });


    $('body').on('click', '.twitter-share', function (e) {
      e.preventDefault();
      window.open("http://twitter.com/intent/tweet?text=" + $(this).data('url'), 'twShareWindow', 'height=550, width=550, top=' + ($(window).height() / 2 - 275) + ', left=' + ($(window).width() / 2 - 275) + ', toolbar=0, location=0, menubar=0, directories=0, scrollbars=0');
      return false;
    });
  },
};

module.exports = ShareButtons;
